import { Component, Inject, Input, OnInit, OnChanges } from '@angular/core';
import { Vehicle } from '../../../shared/domain/vehicle';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { EnvironmentService } from '@nw/ui-core-shared/services';
import { VehicleLiveblockAuctionService } from "../../../shared/services/vehicle-liveblock-auction.service";

@Component({
    selector   : 'nw-runlist-liveblock-item-v1',
    templateUrl: './runlist-liveblock-item-v1.component.html'
})

export class RunlistLiveblockItemV1Component implements OnInit, OnChanges {
    @Input() vehicle: Vehicle;
    @Input() saleEvents;
    @Input() isRunList;
    @Input() isLiveBlock;
    @Input() isWorkInProgress;

    buyerOaUrl;
    showAutoBid: boolean;
    autoBidMode = '';
    AUTO_BID = 'autobid';
    MY_AUTO_BID = 'my-autobid';
    PRE_BID = 'pre-bid';
    isMobileDevice = false;

    constructor(private mainStoreService: MainStoreService,
                private vehicleLiveblockAuctionService: VehicleLiveblockAuctionService,
                @Inject('windowObject') private window: any,
                private environmentService: EnvironmentService) {
        mainStoreService.getStore().select(state => state).subscribe(appMainState => {
            this.isMobileDevice = appMainState.appUiState.isMobileDevice;
        });
    }

    ngOnInit() {
        this.showAutoBid = this.showAutoBidContainer();
        this.buyerOaUrl = this.environmentService.getEnvironment().interfacePath.buyerOa;
    }

    ngOnChanges() {
        this.showAutoBid = this.showAutoBidContainer();
    }

    navigateToJoinNow() {
        if (!this.isMobileDevice) {
            if (this.vehicle.externalAuctionUrl) {
                this.window.open(`${this.vehicle.externalAuctionUrl}`, '_blank');
            } else {
                this.window.open(`${this.buyerOaUrl}/joinLAI.html?vehicleId=${this.vehicle.originalVehicleId}`, '_blank');
            }
        } else {
            if (this.vehicle.externalAuctionUrl) {
                this.window.open(`${this.vehicle.externalAuctionUrl}`, '_blank');
            } else {
                this.vehicleLiveblockAuctionService.showJoinMobileView(this.vehicle);
            }
        }
    }

    private showAutoBidContainer() {
        if (this.vehicle.allowAutobid && this.vehicle.autobidWindowStartTimeRemaining === 0) {
            this.autoBidMode = this.vehicle.externalAuctionUrl ? (this.PRE_BID) : ( (this.vehicle.autobidAmount && this.vehicle.autobidAmount !== 0 && !this.vehicle.autobidIsRemoved) ? this.MY_AUTO_BID : this.AUTO_BID );
            return true;
        } else if (this.vehicle.allowAutobid && this.vehicle.autobidWindowStartTimeRemaining > 0) {
            // Set timeOut on autobidWindowStartTimeRemaining
            setTimeout(() => {
                this.vehicle.autobidWindowStartTimeRemaining = 0;
                this.showAutoBid = this.showAutoBidContainer();
            }, this.vehicle.autobidWindowStartTimeRemaining);
        }
        return false;
    }

    navigateToClassicAutobid() {
        if (!this.isMobileDevice) {
            if (this.vehicle.externalAuctionUrl) {
                this.window.open(`${this.vehicle.externalAuctionUrl}`, '_blank');
            } else {
                this.window.open(`${this.buyerOaUrl}/autoBidDetails.html?vehicleId=${this.vehicle.originalVehicleId}`, '_self');
            }
        } else {
            if (this.vehicle.externalAuctionUrl) {
                this.window.open(`${this.vehicle.externalAuctionUrl}`, '_blank');
            } else {
                this.vehicleLiveblockAuctionService.showAutobidMobileView(this.vehicle);
            }
        }

    }

    returnAuctionEndTime() {
        let currentTime =  new Date().getTime();
        return this.vehicle.actualEndTime < currentTime;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/runlist-liveblock-item-v1/runlist-liveblock-item-v1.component.ts